import keyMirror from '../assets/libs/keyMirror';

const STATUS = {
  uploading: null,
  upload_fail: null,
  sending: null,
  cancel_sending: null,
  success: null,
  fail: null,
  downloading: null,
  download_fail: null,
  download_success: null,
  video_play_error: null
};

export default keyMirror(STATUS);